import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { Wire, WireTemplate } from '@treasury/domain/wires';
import { TmBaseComponent, TmFooterService } from '@treasury/presentation';
import { informationIcon } from '@treasury/presentation/assets/icons';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '../../partials/wire-data-readonly';
import { WireAction } from '../../types/wire-workflow-parameters.type';
import '../partials/wire-template-readonly';

export const tagName = 'wire-template-review-step';
@customElement(tagName)
export class WireTemplateReviewStep extends TmBaseComponent {
    @InjectProperty()
    declare private readonly footerService: TmFooterService;

    @state()
    private wire: Wire = new Wire();

    @state()
    private wireTemplate: WireTemplate = new WireTemplate();

    @state()
    private action = '' as WireAction;

    protected firstUpdated() {
        this.configureFooter();
    }

    protected render() {
        return this.action === 'initiate' ? this.renderWire() : this.renderWireTemplate();
    }

    private configureFooter() {
        this.footerService.configure({
            direction: 'column',
            buttonConfig: [
                {
                    text: this.action === 'initiate' ? 'Initiate wire' : 'Confirm',
                    onClick: () => {
                        this.dispatchEvent(
                            new CustomEvent('confirm', {
                                detail: this.action === 'initiate' ? this.wire : this.wireTemplate,
                            })
                        );
                    },
                },
            ],
        });
    }

    private renderWire() {
        return html`<wire-data-readonly
                .wire=${this.wire}
                @view-creditor-detail=${() => {
                    this.dispatchEvent(new CustomEvent('view-creditor-detail', { detail: true }));
                }}
            ></wire-data-readonly>
            <div class="px-6 py-4">
                <div class="flex">
                    <tm-icon
                        .icon=${informationIcon}
                        color="var(--secondary-text-color)"
                        width="18px"
                        height="18px"
                    ></tm-icon>
                    <div class="text-sm text-secondary pl-2">
                        <p>
                            Fees may be assessed for sending a wire payment. Please check your fee
                            schedule for current fees.
                        </p>
                        <p class="pt-3">
                            Additions or edits to purpose, additional information or End to End ID
                            will not be saved to the wire template.
                        </p>
                    </div>
                </div>
            </div>`;
    }

    private renderWireTemplate() {
        return html` <wire-template-readonly
            .wireTemplate=${this.wireTemplate}
            @view-creditor-detail=${() => {
                this.dispatchEvent(new CustomEvent('view-creditor-detail', { detail: true }));
            }}
        ></wire-template-readonly>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: WireTemplateReviewStep;
    }
}
